import Factory from '@leverege/factory'

import IsaClzz from './Isa.js'
import PluginsClzz from './Plugins.js'
import Context from './Context.js'
import Match from './Match.js'
import Layout from './Layout.js'
import Config from './Config.js'
import Util from './Util.js'
import View from './View.js'
import PluginCreator from './PluginCreator.js'

const Plugins = new PluginsClzz()
const Isa = new IsaClzz()
const resolve = Util.resolve

export {
  Plugins,
  Isa,
  Factory,
  Context,
  PluginCreator,
  Match,
  Layout,
  View,
  Config,
  Util,
  resolve
}
